/* eslint-disable no-unused-expressions */

import React from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';

const FormItem = Form.Item;

const Base = ({
  field,
  form,
  hasFeedback,
  label,
  submitCount,
  component,
  valueExtractor,
  itemStyle,
  handleOnBlur,
  ...props
}) => {
  const Component = component;
  const touched = form.touched[field.name];
  const submitted = submitCount > 0;
  const hasError = form.errors[field.name];
  const onChange = value => form.setFieldValue(field.name, value);
  const onBlur = () => {
    form.setFieldTouched(field.name, true);
    handleOnBlur && handleOnBlur();
  };

  return (
    <FormItem
      label={label}
      hasFeedback={!!((hasFeedback && submitted) || (hasFeedback && touched))}
      help={hasError || false}
      validateStatus={hasError ? 'error' : 'success'}
      style={itemStyle}
    >
      <Component
        {...field}
        {...props}
        onBlur={onBlur}
        onChange={e => onChange(valueExtractor(e))}
      />
    </FormItem>
  );
};

Base.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
  }).isRequired,
  hasFeedback: PropTypes.bool,
  label: PropTypes.string,
  submitCount: PropTypes.number,
  component: PropTypes.func.isRequired,
  valueExtractor: PropTypes.func,
  handleOnBlur: PropTypes.func,
  itemStyle: PropTypes.shape({}),
};

Base.defaultProps = {
  submitCount: 0,
  hasFeedback: false,
  handleOnBlur: null,
  valueExtractor: ({ target: { value } }) => value,
  label: '',
  itemStyle: null,
};

export default Base;
